/** VUEX module for contract management */
import Vue from 'vue';

export default {
  namespaced: true,
  state: {
    // initial state
    entities: {},
    list: [],
    currentCluster: null,
    previousCluster: null,
    nextCluster: null,
    selectedClusterIndex: null,
  },
  getters: {
    // getters
    /**
     * Return array of resources.
     */
    list: state => {
      return state.list.map(id => state.entities[id.toString()]);
    },
    /**
     * Get resource by id.
     */
    byId: state => {
      return id => state.entities[id.toString()];
    },
    /**
     * Get current cluster.
     */
    currentCluster: state => {
      return state.currentCluster;
    },
    /**
     * Get previous cluster.
     */
    previousCluster: state => {
      return state.previousCluster;
    },
    /**
     * Get nex cluster.
     */
    nextCluster: state => {
      return state.nextCluster;
    },
    /**
     * Get selected cluster index.
     */
    selectedClusterIndex: state => {
      return state.selectedClusterIndex;
    },
  },
  mutations: {
    TEST_PERFORMED_CLUSTER: (state, clusterId) => {
      state.entities[clusterId.toString()].test_performed = true;
    },
    // mutations
    SET_CURRENT_CLUSTER: (state, clusterIndex) => {
      state.selectedClusterIndex = clusterIndex;
      state.currentCluster = state.entities[state.list[clusterIndex].toString()];

      if (clusterIndex - 1 >= 0) {
        state.previousCluster = state.entities[state.list[clusterIndex - 1].toString()];
      } else if (clusterIndex - 1 < 0) {
        state.previousCluster = null;
      }

      if (clusterIndex + 1 <= state.list.length - 1) {
        state.nextCluster = state.entities[state.list[clusterIndex + 1].toString()];
      } else if (clusterIndex + 1 > state.list.length - 1) {
        state.nextCluster = null;
      }
    },
    FETCH_LIST_SUCCESS: (state, response) => {
      const { data } = response;

      data.forEach(m => {
        Vue.set(state.entities, m.id.toString(), m);
      });

      state.list = data.map(m => m.id.toString());
    },
    FETCH_LIST_ERROR: state => {
      state.list = [];
    },
    FETCH_SINGLE_SUCCESS: (state, response) => {
      const { data } = response;
      const id = data[id].toString();

      Vue.set(state.entities, id, data);
    },
  },
  actions: {
    // actions
    FETCH_LIST: ({ commit, state }, payload) => {
      state.list = [];
      commit('app/START_PROCESSING', null, { root: true });
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$httpMain({
            url: `clusters?subject_id=${payload.subject_id}`,
            method: 'GET',
          })
          .then(response => {
            resolve(response);
            commit('FETCH_LIST_SUCCESS', response);
          })
          .catch(err => {
            reject(err);
            commit('FETCH_LIST_ERROR', err);
          })
          .finally(() => {
            commit('app/STOP_PROCESSING', null, { root: true });
          });
      });
    },
    FETCH_SINGLE: ({ commit }, payload) => {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$httpMain({
            url: `clusters/${payload.clusterId}?subject_id=${payload.subjectId}`,
            method: 'GET',
          })
          .then(response => {
            resolve(response);
            commit('FETCH_SINGLE_SUCCESS', response);
          })
          .catch(err => {
            reject(err.response);
          });
      });
    },
  },
};
